import { getInitialTheme, normalizeTheme, storeTheme } from "./_theme-core";

function applyTheme(theme) {
  const normalizedTheme = normalizeTheme(theme);

  document.documentElement.dataset.bsTheme = normalizedTheme;

  if (document.body) {
    document.body.classList.toggle("site-theme--dark", normalizedTheme === "dark");
    document.body.classList.toggle("site-theme--light", normalizedTheme === "light");
  }

  document.querySelectorAll("[data-theme-toggle]").forEach((toggle) => {
    const label = normalizedTheme === "dark" ? toggle.dataset.themeLightLabel : toggle.dataset.themeDarkLabel;
    toggle.setAttribute("aria-label", label);
    toggle.title = label;
    toggle.hidden = false;
  });
}

let themeTransition;

function changeTheme(theme) {
  themeTransition?.skipTransition();
  if (!document.startViewTransition || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    applyTheme(theme);
    return;
  }

  // Crossfade snapshots, avoiding layout changes and conflicts with scroll reveals.
  document.documentElement.classList.add("site-theme-transition");
  const transition = document.startViewTransition(() => applyTheme(theme));
  themeTransition = transition;
  transition.finished.catch(() => {}).finally(() => {
    if (themeTransition !== transition) return;
    document.documentElement.classList.remove("site-theme-transition");
    themeTransition = null;
  });
}

function bindThemeToggles() {
  document.querySelectorAll("[data-theme-toggle]").forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const theme = document.documentElement.dataset.bsTheme === "dark" ? "light" : "dark";
      storeTheme(theme);
      changeTheme(theme);
    });
  });
}

applyTheme(getInitialTheme());

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindThemeToggles);
} else {
  bindThemeToggles();
}
